import { defineStore } from 'pinia';
import type { Ref } from 'vue';
import { ref } from 'vue';

import { isNonEmptyString } from '@nora-monorepo/shared';

export const defaultTextToolFontSize = 14;

function textToolStore(): {
  fontSize: Ref<number>;
  text: Ref<string>;
  reset: () => void;
} {
  const fontSize = ref<number>(defaultTextToolFontSize);
  const text = ref<string>('');

  const reset = (): void => {
    fontSize.value = defaultTextToolFontSize;
    text.value = '';
  };

  return {
    fontSize,
    reset,
    text,
  };
}

export function useTextToolStore(storeId?: string | null) {
  if (!isNonEmptyString(storeId)) {
    return defineStore(`textToolStore`, textToolStore)();
  }

  return defineStore(`textToolStore-${storeId}`, textToolStore)();
}

export default useTextToolStore;
